import React, { useEffect, useMemo, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';
import { RadioButton } from './RadioButton';
import { RadioButtonsGroupContainer } from './styled';
export function RadioButtonsGroup({ name, isRightToLeft, radioButtonsArgs, className, checkedCurrentValue, }) {
    const defaultCheckedButton = useMemo(() => {
        const defaultCheckedButtonOption = radioButtonsArgs.filter((button) => button.isChecked);
        return isEmpty(defaultCheckedButtonOption) ? '' : last(defaultCheckedButtonOption)?.value;
    }, [radioButtonsArgs]);
    const [selectedRadioButton, setSelectedRadioButton] = useState(defaultCheckedButton);
    useEffect(() => {
        if (defaultCheckedButton) {
            setSelectedRadioButton(defaultCheckedButton);
        }
    }, [defaultCheckedButton]);
    const onInputChange = (e) => {
        setSelectedRadioButton(e.currentTarget.value);
        if (checkedCurrentValue) {
            checkedCurrentValue(e.currentTarget.value);
        }
    };
    return (React.createElement(RadioButtonsGroupContainer, { className: className, isRightToLeft: isRightToLeft }, radioButtonsArgs.map((button) => (React.createElement(RadioButton, { key: button.id, id: button.id, name: name, value: button.value, label: button.label, additionalText: button.additionalText, cornerText: button.cornerText, isChecked: selectedRadioButton === button.value, isDisabled: button.isDisabled, isRightToLeft: isRightToLeft, onChange: onInputChange })))));
}
